import {NgModule} from "@angular/core";
import {SakRedigerKontrollerAvhengigheter} from "./komponenter/sak-rediger/sak-rediger";
import {NyeSakerSkjemaKontrollerAvhengigheter} from "web-ng2/moduler/sak/komponenter/nye-saker-skjema/nye-saker-skjema";
import {SakNyKontrollerAvhengigheter} from "web-ng2/moduler/sak/komponenter/sak-ny/sak-ny";
import {SakKommentarerKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/sak-kommentarer/sak-kommentarer";
import {SakslisteKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/saksliste/saksliste";
import {SakslisteAjsKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/saksliste-ajs/saksliste-ajs";
import {SakListevisningKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/sak-listevisning/sak-listevisning";
import {PauseRedigerKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/pause-rediger/pause-rediger";
import {SakslisteProgresjonKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/saksliste-progresjon/saksliste-progresjon";
import {SakListeOppgaverKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/sak-liste-oppgaver/sak-liste-oppgaver";
import {SakListeBeslutningerKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/sak-liste-beslutninger/sak-liste-beslutninger";
import {KopierSakDialogKomponentAvhengigheter} from "web-ng2/moduler/sak/modale/kopier-sak-dialog/kopier-sak-dialog";
import {FlyttSakDialogKomponentAvhengigheter} from "web-ng2/moduler/sak/modale/flytt-sak-dialog/flytt-sak-dialog";
import {SakVisKompaktKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/sak-vis-kompakt/sak-vis-kompakt";
import {SakRedigerReferatKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/sak-rediger-referat/sak-rediger-referat";
import {RegistrerSaksdokumentDialogKomponentAvhengigheter} from "web-ng2/moduler/sak/modale/registrer-saksdokument-dialog/registrer-saksdokument-dialog";
import {SaksprogresjonKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/saksprogresjon/saksprogresjon";
import {SakListeDokumenterKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/sak-liste-dokumenter/sak-liste-dokumenter";
import {SakVisKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/sak-vis/sak-vis";
import {PauseVisKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/pause-vis/pause-vis";
import {SakListeOgDetaljerKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/sak-liste-og-detaljer/sak-liste-og-detaljer";
import {ValgtSakRegister} from "web-ng2/tjenester/ValgtSakRegister";
import {SakListeAvstemningerKomponentAvhengigheter} from "web-ng2/moduler/sak/komponenter/sak-liste-avstemninger/sak-liste-avstemninger";
import {SaksdokumentOpplastingFabrikk} from "web-ng2/moduler/sak/tjenester/SaksdokumentOpplasting";

@NgModule({
    providers: [
        SakRedigerKontrollerAvhengigheter,
        PauseRedigerKomponentAvhengigheter,
        NyeSakerSkjemaKontrollerAvhengigheter,
        KopierSakDialogKomponentAvhengigheter,
        SakNyKontrollerAvhengigheter,
        SakKommentarerKomponentAvhengigheter,
        SakslisteKomponentAvhengigheter,
        SakslisteAjsKomponentAvhengigheter,
        SakListevisningKomponentAvhengigheter,
        SakslisteProgresjonKomponentAvhengigheter,
        SakListeOppgaverKomponentAvhengigheter,
        SakListeBeslutningerKomponentAvhengigheter,
        FlyttSakDialogKomponentAvhengigheter,
        SakVisKompaktKomponentAvhengigheter,
        SakRedigerReferatKomponentAvhengigheter,
        RegistrerSaksdokumentDialogKomponentAvhengigheter,
        SaksprogresjonKomponentAvhengigheter,
        RegistrerSaksdokumentDialogKomponentAvhengigheter,
        SakListeDokumenterKomponentAvhengigheter,
        SakVisKomponentAvhengigheter,
        PauseVisKomponentAvhengigheter,
        SaksdokumentOpplastingFabrikk,
        SakListeOgDetaljerKomponentAvhengigheter,
        SakListeAvstemningerKomponentAvhengigheter,
        ValgtSakRegister
    ]
})
export class SakModul{

}
